export const environment = {
    portalApi: 'https://cors-header-proxy.bravo-a.workers.dev/',
    lang: "tr"
};
